import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl'
import { Link } from 'react-router-dom'
import { formatTime, formatLocation, croppedImg } from 'utils'

import { clearReservation as clearReservationAction } from 'actions/reservation'

class CellarEvent extends React.Component {
  constructor(props) {
    super(props)

    this.resetBeforeRouteChange = this.resetBeforeRouteChange.bind(this)
  }

  resetBeforeRouteChange() {
    const { clearReservation } = this.props

    clearReservation()

    return false
  }

  render() {
    const {
      event,
      locale,
    } = this.props

    if (
      window.firstAccessQueryString.showLocation &&
      event.location._id !== window.firstAccessQueryString.showLocation
    ) {
      return null
    }

    const priceMode = event.prices.length > 1
      ? 'from'
      : event.price.mode
    const priceValue = Math.min(...event.prices, event.price.value)

    return (
      <div
        className="event-container"
        style={{
          opacity: (
            !event.dates.length &&
              !event.propose &&
              !(event.reservationMode === 'view')
          )
            ? 0.65
            : 1,
        }}
      >
        <Link
          className="event-box"
          to={
            `/${locale}/${event.cellar._id}/events/${event._id}` +
            `?lang=${event.language}&guests=${event.minGuests}`
            // guests was Math.max(event.minGuests, 2), maybe for a reason?
          }
          onClick={this.resetBeforeRouteChange}
        >
          <div className="event-box__content">
            <div className="event-box__image">
              <div className="event-box__image__labels">
                {
                  event.reservationMode === 'video' && <div className="event-box__image__label">
                    <i className="icon--video-camera icon--huge" />
                    <span>LiveRoom</span>
                  </div>
                }
                {
                  event.private && <div className="event-box__image__label">
                    <i className="icon--eye icon--huge" />
                    <FormattedMessage id="app.cellar.event.private_tour" />
                  </div>
                }
              </div>
              <img
                src={croppedImg(event.mainImage, 730, 360)}
              />
            </div>
            <h3 className="event-box__title">
              {event.title}
            </h3>
            {event.subtitle && <h4 className="event-box__subtitle">
              {event.subtitle}
            </h4>}
            <div
              className="event-box__description"
              dangerouslySetInnerHTML={{
                __html: event.summary || event.description,
              }}
            >
            </div>
            <div className="event-box__info">
              <p className="event-box__row">
                <span className="event-box__row__label">
                  <FormattedMessage id="app.cellar.event.place" />
                </span>
                <span className="event-box__row__value">
                  {formatLocation(event.location)}
                </span>
              </p>
              <p
                className="event__row"
                style={{ visibility: event.hideDuration ? 'hidden' : '' }}
              >
                <span className="event-box__row__label">
                  <FormattedMessage id="app.cellar.event.duration" />
                </span>
                <span className="event-box__row__value">
                  {formatTime(event.duration)}
                </span>
              </p>
            </div>
            <div className="event-box__footer">
              <div className="or">
                <div
                  className="or__item"
                  style={{ visibility: event.hidePrice ? 'hidden' : '' }}
                >
                  <FormattedHTMLMessage
                    id={`app.cellar.event.price_html.${priceMode}${event.default_product_singular ? '.custom' : ''}`}
                    values={{ amount: priceValue, currency: event.location.currency, customText: event.default_product_singular }}
                  />
                </div>
                <div className="or__item">
                  <span className="button--small button--primary">
                    <FormattedMessage id={
                      (
                        !event.dates.length &&
                        !event.propose &&
                        !(event.reservationMode === 'view')
                      )
                        ? 'app.cellar.event.no-dates-available'
                        : `app.cellar.event.cta.${
                          event.reservationMode === 'view' ? 'infos' : 'book'
                        }`
                    }
                    />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </Link>
      </div>
    )
  }
}

CellarEvent.propTypes = {
  event: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  clearReservation: PropTypes.func.isRequired,
}

function mapStateToProps() {
  return {}
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    clearReservation: clearReservationAction,
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(CellarEvent)
